
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program-at-a-glance/[[...slug]]",
      function () {
        return require("private-next-pages/program-at-a-glance/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program-at-a-glance/[[...slug]]"])
      });
    }
  